import { useSocketManager } from './hooks/useSocketManager';
import { useTabManager } from '@/shared/hooks/useTabManager';
import './UseHere.scss';
import { useLanguage } from '@/app/providers';

/**
 * UseHere Component
 * Manages multi-tab coordination to ensure only one tab is active at a time
 * Displays an overlay in inactive tabs with option to take control
 */
const UseHere = () => {
   const { t } = useLanguage();
   const { tabId, isThisTabActive, isTakingControl, handleTakeControl } = useTabManager();

   // Manage SDK socket connection based on tab activity
   useSocketManager(isThisTabActive, tabId);

   // Don't render overlay if this tab is active
   if (isThisTabActive) {
      return null;
   }

   return (
      <dialog className="use-here-overlay ct-flex ct-fcol ct-aiCenter ct-jcCenter" open aria-labelledby="use-here-title">
         <div className="overlay-content ct-flex ct-fcol ct-aiCenter ct-gap16">
            <div className="overlay-icon ct-flex ct-aiCenter ct-jcCenter" aria-hidden="true">
               {/* Using CSS-based icon instead of SVG for better accessibility */}
               <div className="monitor-icon"></div>
            </div>
            <h2 id="use-here-title">{t('common.USE_HERE_TITLE')}</h2>
            <p>{t('common.USE_HERE_DESC')}</p>
            <button
               className={`use-here-button ${isTakingControl ? 'loading' : ''}`}
               onClick={handleTakeControl}
               disabled={isTakingControl}
               aria-busy={isTakingControl}
               aria-live="polite"
            >
               {isTakingControl ? t('common.USE_HERE_OPENING') : t('common.USE_HERE_BTN')}
            </button>
         </div>
      </dialog>
   );
};

export default UseHere;
